import React, { useEffect } from "react";
import aboutImg from "../assets/realestate/about.png";
import { Helmet } from "react-helmet-async";
import seoData from "../assets/data/seo.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy, faHandshake, faGlobe, faBuilding } from "@fortawesome/free-solid-svg-icons";
const Aboutus = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const seo = seoData["aboutus"] || {};
  const { title, description, keywords, canonical, ogImage } = seo;

  return (
    <div className="min-h-screen bg-white font-sans pt-24">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        {canonical && <link rel="canonical" href={canonical} />}
        {ogImage && <meta property="og:image" content={ogImage} />}
      </Helmet>
      {/* Hero Section */}
      <section className="relative py-32 bg-primary text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src={aboutImg} alt="About Jetty Estates" className="w-full h-full object-cover" />
        </div>
        <div className="container mx-auto px-6 relative z-10 text-center">
          <span className="text-secondary font-black tracking-[0.3em] uppercase mb-4 block text-[14px]">About Us</span>
          <h1 className="font-bold mb-6 tracking-tight text-[32px] md:text-[48px] lg:text-[64px]">
            Redefining <span className="text-secondary italic font-medium text-[32px] md:text-[48px] lg:text-[64px]">Luxury</span>
          </h1>
          <p className="text-slate-300 font-light max-w-3xl mx-auto text-[12px] md:text-[14px] lg:text-[16px]">
            Jetty Estates is a premier luxury real estate company dedicated to providing an unparalleled client experience.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 text-slate-700 text-sm md:text-base lg:text-lg leading-relaxed font-light">
            <div className="space-y-8">
              <p>
                <span className="text-6xl font-serif text-secondary float-left mr-4 leading-none mt-2">I</span>n 1940, Mr. Jetty Surya Rao began a journey with an unwavering belief that trust is the strongest foundation any business can have. Starting with a jewelry business, he earned not only success but something far more valuable—the confidence of thousands of families.
              </p>
              <p>
                That trust became the cornerstone of a diversified business empire spanning hospitality, manufacturing, natural resources, agriculture, petroleum, and strategic land banking.
              </p>
              <p>
                While businesses expanded, one vision remained constant: understanding the true value of land long before others recognized its potential. From an initial investment of just 300 square yards, the Jetty Group has grown into one of the largest land bank owners in the Godavari districts, with a carefully curated portfolio exceeding 2,000 acres.
              </p>
            </div>
            
            <div className="lg:w-1/2 space-y-8">
              <h2 className="font-black text-primary tracking-tighter text-[26px] md:text-[48px]">
                A Legacy of <span className="text-secondary italic font-light text-[14px]">Excellence</span>
              </h2>
              <div className="w-20 h-1 bg-secondary" />
              <p className="text-slate-600 leading-relaxed font-light text-[12px] md:text-[14px] lg:text-[16px]">
                Founded on the principles of integrity, market expertise, and an unwavering commitment to our clients, Jetty Estates has quickly established itself as the preeminent luxury real estate company in the region.
              </p>
              <p className="text-slate-600 leading-relaxed font-light text-[12px] md:text-[14px] lg:text-[16px]">
                We don't just sell homes; we curate lifestyles. Our hand-selected team of elite agents possesses intimate knowledge of the most exclusive neighborhoods, ensuring that whether you are acquiring a skyline penthouse or a sprawling countryside manor, your expectations are not just met, but exceeded.

              </p>
              
              <div className="mt-12 p-8 bg-white rounded-3xl border-l-4 border-secondary shadow-xl hover:-translate-y-2 transition-transform">
                <p className="text-xl md:text-2xl font-serif italic text-primary text-center">
                  "Because at Jetty Estates, we don't simply build homes.<br/>We build trust that lasts for generations."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Core Values */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="font-black text-primary tracking-tighter text-[26px] md:text-[48px]">Our Core <span className="text-secondary italic font-light text-[14px]">Values</span></h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: faTrophy, title: "Excellence", desc: "Setting the standard in luxury real estate." },
              { icon: faHandshake, title: "Integrity", desc: "Honest, transparent, and ethical practices." },
              { icon: faGlobe, title: "Global Reach", desc: "Connecting buyers and sellers worldwide." },
              { icon: faBuilding, title: "Innovation", desc: "Utilizing modern tech to market properties." }
            ].map((val, i) => (
              <div key={i} className="bg-white p-10 rounded-[2rem] text-center shadow-lg hover:-translate-y-2 transition-transform border border-slate-100">
                <div className="w-16 h-16 bg-primary text-secondary rounded-full flex items-center justify-center text-2xl mx-auto mb-6">
                  <FontAwesomeIcon icon={val.icon} />
                </div>
                <h3 className="font-black text-primary mb-3 text-[24px] md:text-[30px]">{val.title}</h3>
                <p className="text-slate-500 font-light text-[12px] md:text-[14px] lg:text-[16px]">{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Aboutus;
